import { render, staticRenderFns } from "./UITextField.vue?vue&type=template&id=1af557e9&scoped=true"
import script from "./UITextField.vue?vue&type=script&lang=js"
export * from "./UITextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af557e9",
  null
  
)

export default component.exports